
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as auth_45completeBsuJ8XDglAMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/auth-complete.vue?macro=true";
import { default as indexCAnUIc3CDFMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/index.vue?macro=true";
import { default as loginYkgYMwZaz3Meta } from "C:/vnimpex/tcms-framework-test-3001/pages/login.vue?macro=true";
import { default as onboardingX1DmaYvoYyMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/onboarding.vue?macro=true";
import { default as _91analysisId_93ZeWneam55wMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/analyze/[analysisId].vue?macro=true";
import { default as indexdhLsjtx1SBMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/analyze/index.vue?macro=true";
import { default as indexegPphuoWeyMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/control-picker/index.vue?macro=true";
import { default as _91templateId_93894n6Vzt61Meta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/conversations/[templateId].vue?macro=true";
import { default as indexKoaUq6j3HLMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/conversations/index.vue?macro=true";
import { default as _91documentId_93AUoEJS7zFzMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/documents/[documentId].vue?macro=true";
import { default as indexRY2Igv1sMrMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/documents/index.vue?macro=true";
import { default as tcms_45beschreibungdpSFhLuHSTMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/documents/tcms-beschreibung.vue?macro=true";
import { default as _91templateKey_93dQzKcmfdiRMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/flow-builder/[templateKey].vue?macro=true";
import { default as indexpQgpw2grIXMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/flow-builder/index.vue?macro=true";
import { default as indexLvROcSgsW0Meta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/index.vue?macro=true";
import { default as index97Rw56uRJuMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/invoice-check-log/index.vue?macro=true";
import { default as _91id_93UmHm72HvuKMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/invoice-runs/[id].vue?macro=true";
import { default as _91processInstanceId_938wLG7GFAWKMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/nachweisakte/[processInstanceId].vue?macro=true";
import { default as indexi8sw91PJzlMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/onboarding/index.vue?macro=true";
import { default as _91templateKey_93ep5pN79w53Meta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/procedure-builder/[templateKey].vue?macro=true";
import { default as indexisHq5ZRaJxMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/procedure-builder/index.vue?macro=true";
import { default as _91processId_93cmi5vPjHErMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/processes/[processId].vue?macro=true";
import { default as indexoLt5ttVxa8Meta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/processes/index.vue?macro=true";
import { default as basickYGhoBbdL7Meta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/basic.vue?macro=true";
import { default as goalsrSwHBlEA81Meta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/goals.vue?macro=true";
import { default as indexAFUIGknWb5Meta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/index.vue?macro=true";
import { default as it_45basicsWK59uTBLlrMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/it-basics.vue?macro=true";
import { default as it_45systemsCqIvVzZ2DfMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/it-systems.vue?macro=true";
import { default as organigramxgYDgivCvDMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/organigram.vue?macro=true";
import { default as taxIa5igxxOEhMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/tax.vue?macro=true";
import { default as _91riskId_93AfLfRtGjqVMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/risks/[riskId].vue?macro=true";
import { default as indexccnHZX8MuOMeta } from "C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/risks/index.vue?macro=true";
export default [
  {
    name: "auth-complete",
    path: "/auth-complete",
    meta: auth_45completeBsuJ8XDglAMeta || {},
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/auth-complete.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginYkgYMwZaz3Meta || {},
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/login.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingX1DmaYvoYyMeta || {},
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/onboarding.vue")
  },
  {
    name: "organizations-organizationId-analyze-analysisId",
    path: "/organizations/:organizationId()/analyze/:analysisId()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/analyze/[analysisId].vue")
  },
  {
    name: "organizations-organizationId-analyze",
    path: "/organizations/:organizationId()/analyze",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/analyze/index.vue")
  },
  {
    name: "organizations-organizationId-control-picker",
    path: "/organizations/:organizationId()/control-picker",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/control-picker/index.vue")
  },
  {
    name: "organizations-organizationId-conversations-templateId",
    path: "/organizations/:organizationId()/conversations/:templateId()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/conversations/[templateId].vue")
  },
  {
    name: "organizations-organizationId-conversations",
    path: "/organizations/:organizationId()/conversations",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/conversations/index.vue")
  },
  {
    name: "organizations-organizationId-documents-documentId",
    path: "/organizations/:organizationId()/documents/:documentId()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/documents/[documentId].vue")
  },
  {
    name: "organizations-organizationId-documents",
    path: "/organizations/:organizationId()/documents",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/documents/index.vue")
  },
  {
    name: "organizations-organizationId-documents-tcms-beschreibung",
    path: "/organizations/:organizationId()/documents/tcms-beschreibung",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/documents/tcms-beschreibung.vue")
  },
  {
    name: "organizations-organizationId-flow-builder-templateKey",
    path: "/organizations/:organizationId()/flow-builder/:templateKey()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/flow-builder/[templateKey].vue")
  },
  {
    name: "organizations-organizationId-flow-builder",
    path: "/organizations/:organizationId()/flow-builder",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/flow-builder/index.vue")
  },
  {
    name: "organizations-organizationId",
    path: "/organizations/:organizationId()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/index.vue")
  },
  {
    name: "organizations-organizationId-invoice-check-log",
    path: "/organizations/:organizationId()/invoice-check-log",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/invoice-check-log/index.vue")
  },
  {
    name: "organizations-organizationId-invoice-runs-id",
    path: "/organizations/:organizationId()/invoice-runs/:id()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/invoice-runs/[id].vue")
  },
  {
    name: "organizations-organizationId-nachweisakte-processInstanceId",
    path: "/organizations/:organizationId()/nachweisakte/:processInstanceId()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/nachweisakte/[processInstanceId].vue")
  },
  {
    name: "organizations-organizationId-onboarding",
    path: "/organizations/:organizationId()/onboarding",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/onboarding/index.vue")
  },
  {
    name: "organizations-organizationId-procedure-builder-templateKey",
    path: "/organizations/:organizationId()/procedure-builder/:templateKey()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/procedure-builder/[templateKey].vue")
  },
  {
    name: "organizations-organizationId-procedure-builder",
    path: "/organizations/:organizationId()/procedure-builder",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/procedure-builder/index.vue")
  },
  {
    name: "organizations-organizationId-processes-processId",
    path: "/organizations/:organizationId()/processes/:processId()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/processes/[processId].vue")
  },
  {
    name: "organizations-organizationId-processes",
    path: "/organizations/:organizationId()/processes",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/processes/index.vue")
  },
  {
    name: "organizations-organizationId-profile-basic",
    path: "/organizations/:organizationId()/profile/basic",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/basic.vue")
  },
  {
    name: "organizations-organizationId-profile-goals",
    path: "/organizations/:organizationId()/profile/goals",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/goals.vue")
  },
  {
    name: "organizations-organizationId-profile",
    path: "/organizations/:organizationId()/profile",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/index.vue")
  },
  {
    name: "organizations-organizationId-profile-it-basics",
    path: "/organizations/:organizationId()/profile/it-basics",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/it-basics.vue")
  },
  {
    name: "organizations-organizationId-profile-it-systems",
    path: "/organizations/:organizationId()/profile/it-systems",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/it-systems.vue")
  },
  {
    name: "organizations-organizationId-profile-organigram",
    path: "/organizations/:organizationId()/profile/organigram",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/organigram.vue")
  },
  {
    name: "organizations-organizationId-profile-tax",
    path: "/organizations/:organizationId()/profile/tax",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/profile/tax.vue")
  },
  {
    name: "organizations-organizationId-risks-riskId",
    path: "/organizations/:organizationId()/risks/:riskId()",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/risks/[riskId].vue")
  },
  {
    name: "organizations-organizationId-risks",
    path: "/organizations/:organizationId()/risks",
    component: () => import("C:/vnimpex/tcms-framework-test-3001/pages/organizations/[organizationId]/risks/index.vue")
  }
]